import { Button, Modal } from "semantic-ui-react";
import ReferenceEntry from "../../datatypeComponents/ReferenceEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import StringEntry from "../../datatypeComponents/StringEntry";
import getIdFromReference from "../../functions/getIdFromReference";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAllResourceChanges } from "../../slices/resourceChangeReport/resourceChangeReportSlice";
import { resourceUpdated, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { sectionCodeResults } from "../../dictionaries/CodeSystemLookup";
import updateChangeReport from "../../slices/resourceChangeReport/updateChangeReport";


const submitNewRowChange = (addTableRowModalState, parentResourceDetail, dispatch,
    resourceChanges, foi, setOpenAddTableRowModalState) => {
    if (addTableRowModalState.newRowTitle && addTableRowModalState.newRowFocus) {
        let entryArray = [];
        for (let entryKey of Object.keys(addTableRowModalState)) {
            if (entryKey !== "newRowTitle" && entryKey !== "newRowFocus") {
                entryArray.push(JSON.parse(JSON.stringify(addTableRowModalState[entryKey])));
            }
        }
        let newRow = {
            "title": addTableRowModalState.newRowTitle,
            "code": sectionCodeResults,
            "focus": addTableRowModalState.newRowFocus || { "display": "[No data]" },
            "entry": entryArray
        }
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        newResourceDetail.revisedResourceJson.section.push(newRow);
        console.log("resourceUpdate for Composition.section[]");
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, foi,
            "Composition.section",
            "section[" + newResourceDetail.revisedResourceJson.section.length + "]",
            null,
            newRow);
        setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
    }
};

const addElementValuesForComparativeEvidence = (groupReferencesDictionary, groupKey,
    addTableRowModalState, contained) => {
    if (addTableRowModalState.newRowFocus &&
        getIdFromReference(addTableRowModalState.newRowFocus).indexOf("#") === 0 &&
        contained?.length > 0) {
        for (let resource of contained) {
            if (resource.id === getIdFromReference(addTableRowModalState.newRowFocus).replace("#", "")) {
                return {
                    contained: [
                        resource
                    ],
                    variableDefinition: [
                        {
                            "description": "Parent Population",
                            "variableRole": "population",
                            "observed": { "display": "Parent Population" }
                        },
                        {
                            "description": groupReferencesDictionary[groupKey]?.display,
                            "variableRole": "exposure",
                            "observed": groupReferencesDictionary[groupKey]
                        },
                        {
                            "description": addTableRowModalState.newRowFocus?.display,
                            "variableRole": "outcome",
                            "observed": addTableRowModalState.newRowFocus
                        }
                    ]
                }
            }
        }
    }
    return {
        variableDefinition: [
            {
                "description": "Parent Population",
                "variableRole": "population",
                "observed": { "display": "Parent Population" }
            },
            {
                "description": groupReferencesDictionary[groupKey]?.display,
                "variableRole": "exposure",
                "observed": groupReferencesDictionary[groupKey]
            },
            {
                "description": addTableRowModalState.newRowFocus?.display,
                "variableRole": "outcome",
                "observed": addTableRowModalState.newRowFocus
            }
        ]
    }
}


const AddTableRowModal = ({ resourceLoaded, setOpenAddTableRowModalState, reportType }) => {
    const foi = resourceLoaded.json?.id || resourceLoaded.compositionId;
    const dispatch = useDispatch();
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));

    let noGroups = false;
    const groupReferencesDictionary = resourceLoaded.groupReferencesDictionary;
    const groupKeys = Object.keys(groupReferencesDictionary);
    if (!groupKeys || groupKeys.length === 0) {
        noGroups = true;
    }

    const [addTableRowModalState, setAddTableRowModalState] = useState({
        "newRowTitle": "",
        "newRowFocus": ""
    });
    const [groupsState, setGroupsState] = useState({ "groups": [] });
    const [groupKeysState, setGroupKeysState] = useState([]);
    const [groupReferencesDictionaryState, setGroupReferencesDictionaryState] = useState({});

    useEffect(() => {
        if (groupsState.groups.length > 0) {
            let newGroupKeys = [];
            let newGroupReferencesDictionary = {};
            for (let group of groupsState.groups) {
                let groupId = getIdFromReference(group);
                newGroupKeys.push(groupId);
                newGroupReferencesDictionary[groupId] = group;
            }
            setGroupKeysState(newGroupKeys);
            setGroupReferencesDictionaryState(newGroupReferencesDictionary);
        }
    }, [groupsState])

    let modalContent;

    if (noGroups) {
        modalContent = <div style={{
            paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
            paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
        }}>
            <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
                className="formButton negative"
                content="✖"
                onClick={() => {
                    setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
                }} />
            <h3>Name the Outcome (how it will show in the table row header)</h3>
            <br />
            <StringEntry elementName='newRowTitle' fieldLabel='Title' required
                startingValue={addTableRowModalState.newRowTitle} setResourceState={setAddTableRowModalState} />
            <br />
            <h3>Set or create the structured Outcome Definition</h3>
            <br />
            {reportType === "Participant Flow" ?
                <ReferenceEntry elementName='newRowFocus' enableCreation={true}
                    fieldLabel='ParticipantFlowEvidenceVariable (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
                    startingResourceType="EvidenceVariable" setProfile="ParticipantFlowEvidenceVariable"
                    startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
                :
                <ReferenceEntry elementName='newRowFocus' enableCreation={true}
                    fieldLabel='OutcomeDefinition (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
                    startingResourceType="EvidenceVariable" setProfile="VariableDefinition"
                    startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
            }
            <h3>Set or create the structured Group Resources</h3>
            <br />
            <ArrayEntry datatype='Reference' elementName='groups' enableCreation={true}
                fieldLabel='Group (Resource Reference)' referencedResourceTypes={['Group']}
                startingResourceType="Group"
                startingValue={groupsState.groups} setResourceState={setGroupsState} />
            {groupKeysState.map((groupKey, groupIndex) => { //TODO -- would this ever be reached if noGroups is true?
                return <div key={groupIndex}>
                    <br />
                    <h3>Set or create the structured Evidence for {groupReferencesDictionaryState[groupKey].display}</h3>
                    <br />
                    <ReferenceEntry elementName={groupKey} enableCreation={true}
                        fieldLabel='Evidence (Resource Reference)' referencedResourceTypes={['Evidence']}
                        startingResourceType="Evidence"
                        setProfile={groupReferencesDictionaryState[groupKey].type === "EvidenceVariable" ? "ComparativeEvidence" : "NonComparativeEvidence"}
                        addElementValues={groupReferencesDictionaryState[groupKey].type === "EvidenceVariable" ?
                            addElementValuesForComparativeEvidence(groupReferencesDictionaryState, groupKey,
                                addTableRowModalState, resourceLoaded.json?.contained)
                            :
                            {
                                variableDefinition: [
                                    {
                                        "description": groupReferencesDictionaryState[groupKey]?.display,
                                        "variableRole": "population",
                                        "observed": groupReferencesDictionaryState[groupKey]
                                    },
                                    {
                                        "description": addTableRowModalState.newRowFocus?.display,
                                        "variableRole": "outcome",
                                        "observed": addTableRowModalState.newRowFocus
                                    }
                                ]
                            }
                        }
                        startingValue={addTableRowModalState[groupKey]}
                        setResourceState={setAddTableRowModalState} />
                </div>
            })}
            <br /><br />
            <span>
                <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
                    content="Submit Changes" positive
                    onClick={() => {
                        submitNewRowChange(addTableRowModalState, parentResourceDetail, dispatch,
                            resourceChanges, foi, setOpenAddTableRowModalState);
                    }}
                    disabled={!addTableRowModalState.newRowTitle || !addTableRowModalState.newRowFocus}
                />
                &nbsp;&nbsp;
                {!addTableRowModalState.newRowTitle && <>Enter a title at the top to submit changes.</>}
                {!addTableRowModalState.newRowFocus && <> Enter a focus (EvidenceVariable reference) at the top to submit changes.</>}
            </span>
            <br />
        </div>;
    } else {
        modalContent = <div style={{
            paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
            paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
        }}>
            <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
                className="formButton negative"
                content="✖"
                onClick={() => {
                    setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
                }} />
            <h3>Name the Outcome (how it will show in the table row header)</h3>
            <br />
            <StringEntry elementName='newRowTitle' fieldLabel='Title' required
                startingValue={addTableRowModalState.newRowTitle} setResourceState={setAddTableRowModalState} />
            <br />
            <h3>Set or create the structured Outcome Definition</h3>
            <br />
            {reportType === "Participant Flow" ?
                <ReferenceEntry elementName='newRowFocus' enableCreation={true}
                    fieldLabel='ParticipantFlowEvidenceVariable (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
                    startingResourceType="EvidenceVariable" setProfile="ParticipantFlowEvidenceVariable"
                    startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
                :
                <ReferenceEntry elementName='newRowFocus' enableCreation={true}
                    fieldLabel='OutcomeDefinition (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
                    startingResourceType="EvidenceVariable" setProfile="VariableDefinition"
                    startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
            }
            {groupKeys.map((groupKey, groupIndex) => {
                return <div key={groupIndex}>
                    <br />
                    <h3>Set or create the structured Evidence for {groupReferencesDictionary[groupKey].display}</h3>
                    <br />
                    <ReferenceEntry elementName={groupKey} enableCreation={true}
                        fieldLabel='Evidence (Resource Reference)' referencedResourceTypes={['Evidence']}
                        startingResourceType="Evidence"
                        setProfile={groupReferencesDictionary[groupKey].type === "EvidenceVariable" ? "ComparativeEvidence" : "NonComparativeEvidence"}
                        addElementValues={groupReferencesDictionary[groupKey].type === "EvidenceVariable" ?
                            addElementValuesForComparativeEvidence(groupReferencesDictionary, groupKey,
                                addTableRowModalState, resourceLoaded.json?.contained)
                            :
                            {
                                variableDefinition: [
                                    {
                                        "description": groupReferencesDictionary[groupKey]?.display,
                                        "variableRole": "population",
                                        "observed": groupReferencesDictionary[groupKey]
                                    },
                                    {
                                        "description": addTableRowModalState.newRowFocus?.display,
                                        "variableRole": "outcome",
                                        "observed": addTableRowModalState.newRowFocus
                                    }
                                ]
                            }
                        }
                        startingValue={addTableRowModalState[groupKey]} setResourceState={setAddTableRowModalState} />
                </div>
            })}
            <br /><br /><span>
                <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
                    content="Submit Changes" positive
                    onClick={() => {
                        submitNewRowChange(addTableRowModalState, parentResourceDetail, dispatch,
                            resourceChanges, foi, setOpenAddTableRowModalState);
                    }}
                    disabled={!addTableRowModalState.newRowTitle || !addTableRowModalState.newRowFocus}
                />
                &nbsp;&nbsp;
                {!addTableRowModalState.newRowTitle && <>Enter a title at the top to submit changes.</>}
                {!addTableRowModalState.newRowFocus && <> Enter a focus (EvidenceVariable reference) at the top to submit changes.</>}
            </span>
            <br />
        </div>;
    }

    return (
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={true}
            centered={false}
            content={modalContent}
        />
    )
}

export default AddTableRowModal;